(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["icyu-product-collage"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
var arrow=event.target.closest('.icyu-side-arrow');
if(arrow){
var collage=arrow.closest('.icyu-collage');
var root=collage.closest('.product-img-box');
var panels=Array.from(collage.querySelectorAll('.icyu-collage-shot')).slice(1);
if(!collage.icyuSideImages){
collage.icyuSideImages=panels.concat(Array.from(root.querySelectorAll('.icyu-collage-extra .icyu-collage-shot'))).map(function(p){return {src:p.querySelector('img').getAttribute('src'),full:p.dataset.full,alt:p.getAttribute('aria-label')};});
}
var shots=collage.icyuSideImages;
var index=(Number(collage.dataset.sideIndex)+Number(arrow.dataset.step)+shots.length)%shots.length;
collage.dataset.sideIndex=String(index);
panels.forEach(function(p,n){var shot=shots[(index+n)%shots.length];var img=p.querySelector('img');img.removeAttribute('srcset');img.src=shot.src;img.alt=shot.alt;p.dataset.full=shot.full;p.setAttribute('aria-label',shot.alt);});
return;
}
var shot=event.target.closest('.icyu-collage-shot');
if(window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
if(!shot)return;
var dialog=shot.closest('.product-img-box').querySelector('.icyu-collage-dialog');
var image=dialog.querySelector('img');
image.src=shot.dataset.full;
image.alt=shot.getAttribute('aria-label');
dialog.showModal();
});

function icyuHoverCollage(root){
root.querySelectorAll('.icyu-collage-shot').forEach(function(panel){
if(panel.dataset.hoverBound)return;
panel.dataset.hoverBound='1';
panel.addEventListener('pointerenter',function(e){
if(e.pointerType==='touch'||!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
var img=panel.querySelector('img');
img.removeAttribute('srcset');img.src=panel.dataset.full;
panel.style.setProperty('--icyu-hover-scale','2');
});
panel.addEventListener('pointermove',function(e){
if(e.pointerType==='touch'||!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
var box=panel.getBoundingClientRect();
panel.style.setProperty('--icyu-hover-x',Math.max(0,Math.min(100,(e.clientX-box.left)/box.width*100))+'%');
panel.style.setProperty('--icyu-hover-y',Math.max(0,Math.min(100,(e.clientY-box.top)/box.height*100))+'%');
});
panel.addEventListener('pointerleave',function(){panel.style.setProperty('--icyu-hover-scale','1');});
});
}
icyuHoverCollage(document);
document.addEventListener('shopify:section:load',function(e){icyuHoverCollage(e.target);});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["icyu-product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  var button = event.target.closest('.icyu-unified-thumb');
  if (!button) return;
  var gallery = button.closest('[data-icyu-media-gallery]');
  var photo = gallery.querySelector('.icyu-unified-photo');
  var player = gallery.querySelector('.icyu-unified-player');
  player.querySelectorAll('video').forEach(function (video) { video.pause(); });
  player.replaceChildren();
  gallery.querySelectorAll('.icyu-unified-thumb').forEach(function (item) {
    item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
  });
  if (button.dataset.mediaKind === 'image') {
    var image = photo.querySelector('img');
    image.src = button.dataset.imageSrc;
    image.alt = button.dataset.imageAlt;
    photo.hidden = false;
    player.hidden = true;
  } else {
    var template = gallery.querySelector('template[data-video-template="' + button.dataset.mediaId + '"]');
    player.appendChild(template.content.cloneNode(true));
    photo.hidden = true;
    player.hidden = false;
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["icyu-product-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (event) {
  if (!event.target.matches || !event.target.matches('.icyu-product-video') || event.target.open) return;
  event.target.querySelectorAll('video').forEach(function (video) { video.pause(); });
  event.target.querySelectorAll('iframe').forEach(function (frame) { frame.src = frame.src; });
}, true);
  } catch(e) { console.error(e); }
})();

})();
